import { GameScatterPickBackgroundProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameScatterPickBackgroundProperties";
export class ScatterPickBackgroundPortraitProperties extends GameScatterPickBackgroundProperties {
    constructor() {
        super();
        this.position.set(512, 973);
        this.titleSpineProperties.position.set(0, -520);
        this.instructionsProperties.position.set(0, 475);
    }
}
//# sourceMappingURL=ScatterPickBackgroundPortraitProperties.js.map